<template>
  <div>
    <div class="menu-header-wrap plr16 edv-header" :class="{ overlay: shouldShowOverlay }" id="pageTop">
      <div 
        id="menu-header" 
        class="menu-header-bar focussed plr16 mb16"
      >
        <i @click="handleBackClick()" class="jfi-back-v2"></i>
        <span class="menu-heading">{{ this.modulePropsData.pageHeader }}</span>
      </div>
    </div>
  
    <generic-modal
        v-if="EdvPopUpVisible"            
        :width="'80%'"              
        :height="'fit-content'"             
        :top="'50%'"                   
        :left="'50%'"                                           
        :modalStyle="{
          transform: 'translate(-50%, -50%)', 
          position: 'absolute',
          borderRadius: '8px',              
        }"
      >
        <template v-slot:body>
          <div class="flex-column">
            <p class="bold fs-16">Offer Added</p>
            <p class="fs-12 tl mt15 lh-normal">
              Seems you want to add more items! We have added your EveryDay Value offer to cart. You can modify it later in the cart.
            </p>
            <div class="disp-col-inline jcsb full mt15">
              <span></span>
              <button @click="addEdvtoCart()" class="btn medium">
                OK, GOT IT
              </button>
            </div>
          </div>
        </template>
    </generic-modal>
    <alert-popup v-if="showAlertModal"></alert-popup>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import GenericModal from "./GenericModal.vue";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  v2PwaBasePath,
  projectBasePathWithFolder,
  shouldLoginFlowSkip,
  isCorporateSite,
  showEdvForCorporate,
  keyForStoreStressRegister,
  allowedPageForStoreStress
} from "../config/apiEndpoints";
import { 
  keyMapsMutation, 
  keyMapsGetter,
  keyMapsAction
} from "../helpers/storeKeys";
import PageNames from "../config/pageNames";
import setEvents, { loadAmplitudeUnsentEvents } from "../helpers/events";

export default {
  name: "EdvHeader",
  components: {
    GenericModal,
    AlertPopup: defineAsyncComponent(() =>
      import("./AlertPopup.vue")
    ),
  },
  props: ["moduleProps"],
  data() {
    return {
      modulePropsData : {
        pageHeader: "Everyday Value Offers",
      },
    };
  },
  async mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    const recentLastLocation = Utility.tryJsonParse(localStorage.lastLocationNew)[0]?.recent;
    let edvInStore = recentLastLocation?.edvEnable || false;
    const shouldShowEDV = edvInStore || (isCorporateSite && showEdvForCorporate);
    if(!shouldShowEDV){
      window.location.href =
        projectBasePathWithFolder +
        `/${PageNames.NEXTGEN_LINKREWRITE_HOME}/` +
        LocalStorageFunc.storeId() +
        Utility.getUrlQueryString();
      return;
    }
    const currentPath = window.location.pathname;
    if(currentPath.endsWith(Utility.getCurrentStoreFolder()) || currentPath.endsWith(Utility.getLinkRewriteFromSiteprops())) {
      window.location.href =
        projectBasePathWithFolder +
        Utility.getCurrentStoreFolder() +
        LocalStorageFunc.storeId() +
        Utility.getUrlQueryString();
      return;
    }

    const preEventObj = {
      screenName: PageNames.NEXTGEN_EDVPAGE,
      previousScreenname: PageNames.NEXTGEN_HOMEPAGE,
    };
    const eventObj = Utility.amplitudeEventObj(
      "page view",
      "edv page",
      "-1",
      preEventObj
    );
    setEvents("amplitude", "PageView", eventObj);
    
    this.$store.dispatch(keyMapsAction.PIZZA_TOPPING_API, {}, { root: true });
    const element = document.getElementsByClassName("home-route");
    element[0].style.paddingTop = this.addPaddingtoTop();
    this.scrollToCategoryId();
    this.hidePageLoader();
    Utility.pizzaCounter();
    this.$store.commit(keyMapsMutation.UPDATE_EDV_ITEMS_FROM_LOCAL_STORAGE);

    const storeStressFlag = allowedPageForStoreStress && allowedPageForStoreStress.includes('edv');
    if(keyForStoreStressRegister && storeStressFlag){
      setTimeout(()=> {
        this.$store.dispatch(keyMapsAction.GET_STORE_STRESS_DATA);
      },0);
    }
  },
  methods: {
    hidePageLoader() {
      document.getElementById("pageLoader").style.display = "none";
    },
    scrollToCategoryId() {
      let queryParams = Utility.getQueryFromUrl();
      let categoryName = "default";
      let categoryId = -1;
      const edvType = queryParams["type"] || "";
      const edvSizeMap = JSON.parse(this.modulePropsData.edvSizeMap);
      if (edvType && edvSizeMap[edvType]) {
        categoryName = edvSizeMap[edvType];
        categoryId = Number(edvType);
      }
      setTimeout(() => {
        this.$store.commit(keyMapsMutation.UPDATE_SELECTED_MENU_CATEGORY, {
          category: categoryName,
          id: categoryId,
        });
      }, 0);
    },
    addPaddingtoTop() {
      return "150px"
    },
    previousLinkRewrite(linkRewrite = LocalStorageFunc.getSessionStorageKey('previousLinkRewrite')) {
      if(Object.keys(linkRewrite).length <= 0) {
        linkRewrite = PageNames.NEXTGEN_LINKREWRITE_HOME;
      }
      return `/${linkRewrite}/`;
    },
    redirectToPreviousPage(flag = false) {
      const cartFlag = LocalStorageFunc.getStorageValue("isFromNxgCart");
      if(flag && cartFlag == "true"){
        Utility.sendToNextGenCart();
        return;
      }
      window.location.href =
        projectBasePathWithFolder +
        this.previousLinkRewrite() +
        LocalStorageFunc.storeId() +
        Utility.getUrlQueryString();
    },
    addEdvtoCart() {
      if(Utility.isCartQtyLimitError()){
        Utility.showCartQtyLimitError();
        this.$store.commit(keyMapsMutation.EMPTY_EDV_ITEMS);
        return;
      }
      const preEventObj = {
        category: "Pop up click",
        Event_Label: "OK GOT IT",
        screenName: PageNames.NEXTGEN_EDVPAGE,
        previousScreenname: PageNames.NEXTGEN_HOMEPAGE,
      };
      const eventObj = Utility.amplitudeEventObj(
        "click",
        "edv pop up",
        "-1",
        preEventObj
      );
      setEvents("amplitude", "Click", eventObj);
      this.$store.commit(keyMapsMutation.UPDATE_EDV_POPUP_STATE, false);
      this.$store.commit(keyMapsMutation.ADD_EDV_ITEMS_TO_CART);
      this.redirectToPreviousPage();
    },
    handleBackClick() {
      const preEventObj = {
        category: "back click",
        screenName: PageNames.NEXTGEN_EDVPAGE,
        previousScreenname: PageNames.NEXTGEN_HOMEPAGE,
      };
      const eventObj = Utility.amplitudeEventObj(
        "click",
        "edv top bar",
        "-1",
        preEventObj
      );
      setEvents("amplitude", "Click", eventObj);

      const EdvCount = this.$store.state.Edv.edvItems?.length;
      const maxEdvCount = this.$store.state.Edv.edvMaxQuantity;
      if(Number(EdvCount) === Number(maxEdvCount)){
        this.$store.commit(keyMapsMutation.UPDATE_EDV_POPUP_STATE, true);
        return;
      }
      this.$store.commit(keyMapsMutation.EMPTY_EDV_ITEMS);
      this.redirectToPreviousPage(true);
    },
  },
  computed: {
    EdvPopUpVisible() {
      return this.$store.state.Edv.edvPopUpVisible || false;
    },
    shouldShowOverlay() {
      const showOverlay = Number(this.$store.state.Edv.edvItems.length) === Number(this.$store.state.Edv.edvMaxQuantity);
      return showOverlay;
    },
    showAlertModal() {
      return this.$store.state.DynamicWidget.showAlertModal;
    }
  }
};
</script>

<style></style>